import React from 'react';
import { PlaylistVideo } from '@/store/playlist/types';
import { EpisodeItem } from './EpisodeItem';

interface EpisodeListProps {
  videos: PlaylistVideo[];
  currentIndex: number;
  watchedEpisodes: Set<number>;
  onSelectEpisode: (index: number) => void;
  theme: 'purple' | 'blue' | 'dark' | 'white';
}

export const EpisodeList: React.FC<EpisodeListProps> = ({
  videos,
  currentIndex,
  watchedEpisodes,
  onSelectEpisode,
  theme
}) => {
  return (
    <div className="space-y-2">
      {videos.map((video, index) => (
        <EpisodeItem
          key={video.id}
          video={video}
          index={index}
          isPlaying={index === currentIndex}
          isWatched={watchedEpisodes.has(index)}
          onSelect={() => onSelectEpisode(index)}
          theme={theme}
        />
      ))}
    </div>
  );
};
